import { useEffect, useState } from "react";
import {
  hasBlockingMailMutation,
  subscribeMailMutationProgress,
} from "@/lib/mail/mailMutationProgress";

/** true seulement pour les jobs qui doivent pauser IMAP (pas la prep réception). */
export function useMailMutationActive(): boolean {
  const [active, setActive] = useState(() => hasBlockingMailMutation());

  useEffect(() => {
    return subscribeMailMutationProgress(() => {
      setActive(hasBlockingMailMutation());
    });
  }, []);

  return active;
}
